import React, { useEffect, useState } from 'react';
//MaterialUI Imports
import {
    Alert,
    Autocomplete,
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Snackbar,
    Stack,
    TextField,
    Tooltip,
    Typography,
    CardHeader,
    InputLabel,
    Card,
    CardContent,
    FormControl,
    Select,
    MenuItem,
    Icon
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MainCard from 'ui-component/cards/MainCard';
import { LoadingButton } from '@mui/lab';

//icon imports
import PaymentsIcon from '@mui/icons-material/Payments';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FunctionsIcon from '@mui/icons-material/Functions';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import RefreshIcon from '@mui/icons-material/Refresh';

//services
import useSalesRecordService from 'services/useSalesRecordService';

//project import
import SalaryDetailComponent from '../SalaryDetailComponent';
import { CollectionsOutlined } from '@mui/icons-material';
import useMonthlySaleUnitsService from 'services/useMonthlySaleUnitsService';
import useSalariesService from 'services/useSalariesService';
import useAmountTransactionService from 'services/useAmountTransactionService';

const GLCard = (props) => {
    const { employee, glSalarySlabDetails, glFiledExpensesDetails, glGroupIncentiveDetails, onRefresh, month, year } = props;
    const theme = useTheme();
    const { getAmountTransactionPendingAmount } = useAmountTransactionService();
    const cellWidth = 70;
    //states
    const [submitting, setSubmitting] = useState(false);
    //const [adjustment, setAdjustment] = useState(0);
    const [workDays, setWorkDays] = useState(60);
    const [unitsSold, setUnitsSold] = useState(0);
    const [petrolRate, setPetrolRate] = useState(90);
    const [editMode, setEditMode] = useState(true);
    const [pendingAmountDetails, setPendingAmountDetails] = useState();
    const [glSalaryDetails, SetGLSalaryDetails] = useState({
        fixedSalary: 0,
        units: 0,
        fieldExpenses: 0,
        pri: 0,
        da: 0,
        ta: 0,
        incentive: 0,
        //adjustment: 0,
        petrol: 0,
        deduction: 0,
        netAmount: 0,
        remarks: ''
    });
    const [appliedGLSalarySlab, setAppliedGLSalarySlab] = useState({
        fixedSalary: 0,
        minUnit: 0,
        maxUnit: 9,
        fieldExpenses: 0,
        pri: 0,
        da: 0,
        ta: 0,
        incentive: 0
    });

    const [glGroupIncentiveSalary, setGLGroupIncentiveSalary] = useState({
        fixedSalary: 0,
        units: 0,
        amount: 0
    });
    const [glGroupIncentiveSalarySlabs, setGLGroupIncentiveSalarySlabs] = useState({
        fixedSalary: 0,
        minUnit: 0,
        maxUnit: 9,
        amount: 0
    });
    const [glSalesUnit, setGLSalesUnit] = useState(0);
    const [totalUnits, setTotalUnits] = useState(0);

    //Methods
    const handleGetPendingAmount = () => {
        getAmountTransactionPendingAmount(employee.id, month, year)
            .then((response) => {
                if (response.status == 200) {
                    // console.log('AMOUNTS', response.data);
                    setPendingAmountDetails(response.data);
                } else {
                    console.log(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    //use effects
    useEffect(() => {
        handleGetPendingAmount();
    }, [employee.id, month, year]);

    //services
    const { getUnitsSold } = useSalesRecordService();
    const { getMonthlySaleUnits } = useMonthlySaleUnitsService();
    const { addSalaries } = useSalariesService();
    //handlers
    const handleCalculate = () => {
        //calculated values
        let calcFieldExpenses = appliedGLSalarySlab.fieldExpenses * unitsSold;
        let calcIncentive = appliedGLSalarySlab.incentive;
        let calcPRI = appliedGLSalarySlab.pri;
        let calcDA = appliedGLSalarySlab.da;
        let calcTA = appliedGLSalarySlab.ta;
        let calcPetrol = 0;
        if (employee.haveVehicle && unitsSold > 25) {
            let liters = (unitsSold / 2) * 1.5;
            calcPetrol = (liters > 75 ? 75 : liters) * petrolRate;
        } else {
            calcPetrol = 0;
        }

        const totalUnits = unitsSold - glSalesUnit;
        setTotalUnits(totalUnits);
        let calcAmount = glGroupIncentiveSalarySlabs.amount * totalUnits;
        let calcDeduction = pendingAmountDetails?.amount;
        let calcNetAmount =
            appliedGLSalarySlab.fixedSalary +
            calcFieldExpenses +
            calcPRI +
            calcDA +
            calcTA +
            calcPetrol +
            calcAmount +
            calcIncentive -
            calcDeduction;

        SetGLSalaryDetails((prev) => ({
            ...prev,
            fixedSalary: appliedGLSalarySlab.fixedSalary,
            units: unitsSold,
            fieldExpenses: calcFieldExpenses,
            pri: calcPRI,
            da: calcDA,
            ta: calcTA,
            petrol: calcPetrol,
            incentive: calcIncentive,
            // adjustment: adjustment,
            deduction: calcDeduction,
            netAmount: calcNetAmount
        }));
        setGLGroupIncentiveSalary((prev) => ({
            ...prev,
            fixedSalary: glGroupIncentiveSalarySlabs.fixedSalary,
            units: totalUnits,
            amount: calcAmount
            // netAmount: calcNetAmount
        }));
    };

    const handleSetSalarySlabData = () => {
        console.log(glFiledExpensesDetails);
        let selectedData = glFiledExpensesDetails?.filter((item) => {
            return unitsSold >= item.unitMin && unitsSold <= item.unitMax;
        });
        let glGroupIncentiveData = glGroupIncentiveDetails?.filter((item) => {
            return totalUnits >= item.unitMin && totalUnits <= item.unitMax;
        });
        // //console.log(data);
        if (glGroupIncentiveData.length > 0) {
            let data = {
                fixedSalary: glSalarySlabDetails.fixedSalary,
                minUnit: glGroupIncentiveData[0].unitMin,
                maxUnit: glGroupIncentiveData[0].unitMax,
                amount: glGroupIncentiveData[0].amount
            };
            setGLGroupIncentiveSalarySlabs(data);
            handleCalculate();
        }
        console.log(selectedData);
        if (selectedData.length > 0) {
            let data = {
                fixedSalary: glSalarySlabDetails.fixedSalary,
                minUnit: selectedData[0].unitMin,
                maxUnit: selectedData[0].unitMax,
                fieldExpenses: selectedData[0].fieldExpenses,
                pri: selectedData[0].pri,
                da: selectedData[0].da,
                ta: selectedData[0].ta,
                incentive: selectedData[0].incentive
            };
            setAppliedGLSalarySlab(data);
            handleCalculate();
        }
    };

    const handelGetSalesData = () => {
        getMonthlySaleUnits(employee.id, month, year).then((response) => {
            if (response.status == 200) {
                setUnitsSold(response.data.unit);
            }
        });
    };
    const handelGetSalesMonthlyData = () => {
        getUnitsSold(employee.id, month, year).then((response) => {
            if (response.status == 200) {
                setGLSalesUnit(response.data);
            }
        });
    };

    const glSaveSalary = () => {
        let data = {
            userId: employee.id,
            month: month,
            year: year,
            unitSold: unitsSold,
            workDays: workDays,
            //adjustment: adjustment,
            petrolRate: petrolRate,
            fixedSalary: glSalaryDetails.fixedSalary,
            fieldExpences: glSalaryDetails.fieldExpenses,
            incentive: glSalaryDetails.incentive,
            pri: glSalaryDetails.pri,
            da: glSalaryDetails.da,
            ta: glSalaryDetails.ta,
            petrol: glSalaryDetails.petrol,
            groupIncentive: glGroupIncentiveSalary.amount,
            deduction: glSalaryDetails.deduction,
            netSalary: glSalaryDetails.netAmount,
            remark: 'string'
        };
        console.log('dataapi', data);
        addSalaries(data)
            .then((response) => {
                if (response.status == 200) {
                    console.log(response);
                    //setSaveGCSalary(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    //use effects
    useEffect(() => {
        handleCalculate();
    }, [
        petrolRate,
        workDays,
        totalUnits,
        unitsSold,
        glSalarySlabDetails,
        glFiledExpensesDetails,
        glGroupIncentiveDetails,
        glSalesUnit,
        employee.id
    ]);

    useEffect(() => {
        //handelGetSalesData();
        handelGetSalesMonthlyData();
    }, [month, year, employee.id]);

    useEffect(() => {
        handelGetSalesData();
        //handelGetSalesMonthlyData();
    }, [month, year, employee.id]);
    useEffect(() => {
        if (glSalarySlabDetails && glFiledExpensesDetails && glGroupIncentiveDetails) {
            handleSetSalarySlabData();
        }
    }, [glSalarySlabDetails, glFiledExpensesDetails, glGroupIncentiveDetails, unitsSold, totalUnits, glSalesUnit]);

    return (
        <Card variant="outlined" sx={{ padding: 2, backgroundColor: theme.palette.grey[100] }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="h5" color={theme.palette.grey[500]}>
                        {employee.employeeCode}
                    </Typography>
                    <Typography variant="h5" color={theme.palette.grey[500]}>
                        |
                    </Typography>
                    <Typography variant="h5" color={theme.palette.secondary.main}>
                        {employee.salutationDisplay} {employee.firstName} {employee.middleName} {employee.lastName}
                    </Typography>
                    <Typography variant="h5" color={theme.palette.grey[500]}>
                        |
                    </Typography>
                    <Typography variant="h5" color={theme.palette.grey[500]}>
                        +91-{employee.mobileNumber}
                    </Typography>
                    <Typography variant="h5" color={theme.palette.grey[500]}>
                        |
                    </Typography>
                    {employee.role == 1 && employee.haveVehicle && (
                        <TwoWheelerIcon fontSize="small" sx={{ color: theme.palette.grey[500] }} />
                    )}
                </Stack>
                <Button
                    size="small"
                    onClick={() => {
                        handelGetSalesData();
                        handelGetSalesMonthlyData();
                        handleCalculate();
                    }}
                >
                    <RefreshIcon fontSize="small" />
                </Button>
            </Stack>
            <Divider sx={{ marginY: 2 }} />
            <Stack direction="row" spacing={1}>
                <TextField label="Units Sold" fullWidth size="small" value={unitsSold} />
                <TextField
                    label="Work Days"
                    fullWidth
                    size="small"
                    value={workDays}
                    onChange={(e) => {
                        setWorkDays(e.target.value);
                    }}
                />
                {/* <TextField
                    label="Adjustments"
                    size="small"
                    fullWidth
                    value={adjustment}
                    onChange={(e) => {
                        SetGLSalaryDetails((prev) => ({
                            ...prev,
                            adjustment: e.target.value
                        }));
                    }}
                /> */}
                <TextField
                    label="Petrol Rate"
                    size="small"
                    fullWidth
                    value={petrolRate}
                    onChange={(e) => {
                        setPetrolRate(e.target.value);
                    }}
                />
            </Stack>

            <Divider sx={{ marginY: 2 }} />
            <Stack spacing={1} sx={{ marginX: 2 }}>
                <SalaryDetailComponent
                    title="Fixed Salary"
                    description={`₹ ${glSalaryDetails.fixedSalary} (From Table)`}
                    value={glSalaryDetails.fixedSalary}
                />
                <SalaryDetailComponent
                    title="Filed Expenses"
                    description={`${unitsSold} Units x ₹ ${appliedGLSalarySlab.fieldExpenses} (From Table)`}
                    value={glSalaryDetails.fieldExpenses}
                />
                <SalaryDetailComponent
                    title="Incentive"
                    description={` ₹ ${appliedGLSalarySlab.incentive} (From Table)`}
                    value={glSalaryDetails.incentive}
                />
                <SalaryDetailComponent title="PRI" description={`₹ ${appliedGLSalarySlab.pri} (From Table)`} value={glSalaryDetails.pri} />
                <SalaryDetailComponent title="D.A." description={` ₹ ${appliedGLSalarySlab.da} (From Table)`} value={glSalaryDetails.da} />
                <SalaryDetailComponent title="T.A." description={` ₹ ${appliedGLSalarySlab.ta} (From Table)`} value={glSalaryDetails.ta} />
                <SalaryDetailComponent
                    title="Petrol"
                    description={
                        employee.haveVehicle
                            ? `(${unitsSold} Units / 2) x 1.5 Ltr x ₹ ${petrolRate} (Rate) - Max 75 Ltrs`
                            : 'Not applicable'
                    }
                    value={glSalaryDetails.petrol}
                />
                <SalaryDetailComponent
                    title="Group Incentive"
                    description={`${totalUnits} Units x ₹ ${glGroupIncentiveSalarySlabs.amount} (From Table) `}
                    value={glGroupIncentiveSalary.amount}
                />
                <Divider />
                <SalaryDetailComponent
                    title="Deduction"
                    description={` ₹ ${glSalaryDetails.deduction}`}
                    value={glSalaryDetails.deduction}
                />
                <Divider />
                <SalaryDetailComponent title="Net Salary" value={glSalaryDetails.netAmount} />
                <Divider />
            </Stack>

            <TextField
                label="Remarks"
                fullWidth
                size="small"
                value={glSalaryDetails.remarks}
                sx={{ marginTop: 2 }}
                multiline
                onChange={(e) => {
                    SetGLSalaryDetails((prev) => ({
                        ...prev,
                        remarks: e.target.value
                    }));
                }}
            />

            <Divider sx={{ marginY: 2 }} />
            {/* {editMode ? (
                <> */}
            <Button
                variant="outlined"
                onClick={() => {
                    handleCalculate();
                }}
            >
                Calculate
            </Button>
            <LoadingButton
                loading={submitting}
                variant="contained"
                onClick={() => {
                    // handleCalculate();
                    glSaveSalary();
                    setEditMode(false);
                }}
                sx={{ marginLeft: 2 }}
            >
                Save
            </LoadingButton>
            {/* </>
            ) : (
                <Button
                    variant="outlined"
                    startIcon={<EditIcon />}
                    onClick={() => {
                        setEditMode(true);
                    }}
                >
                    Edit
                </Button>
            )} */}
        </Card>
    );
};

export default GLCard;
